import { editors } from 'react-data-grid'
import { addDirtyColumnToRow } from './util'

export default class CustomEditor extends editors.EditorBase {

  attachRef = (ref) => this.input = ref

  _handleChange = (handler) => (e) => {
    // Dirty columns used in ./DataGrid.js
    addDirtyColumnToRow(this.props.rowData, this.props.column.key)
    return handler && handler(e)
  }

  render() {
    return null
  }
}


// WEBPACK FOOTER //
// ./components/product-detail/CustomEditor.js